import { render, staticRenderFns } from "./AddPlatformtemplateMindestpreis.vue?vue&type=template&id=aab85330&"
import script from "./AddPlatformtemplateMindestpreis.vue?vue&type=script&lang=js&"
export * from "./AddPlatformtemplateMindestpreis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports